"use strict";
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || (function () {
    var ownKeys = function(o) {
        ownKeys = Object.getOwnPropertyNames || function (o) {
            var ar = [];
            for (var k in o) if (Object.prototype.hasOwnProperty.call(o, k)) ar[ar.length] = k;
            return ar;
        };
        return ownKeys(o);
    };
    return function (mod) {
        if (mod && mod.__esModule) return mod;
        var result = {};
        if (mod != null) for (var k = ownKeys(mod), i = 0; i < k.length; i++) if (k[i] !== "default") __createBinding(result, mod, k[i]);
        __setModuleDefault(result, mod);
        return result;
    };
})();
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UserModalBody = UserModalBody;
const react_1 = __importStar(require("react"));
const react_bootstrap_1 = require("react-bootstrap");
const MainSetupReact_1 = __importDefault(require("../../../React/MainSetupReact"));
const BussinesObjectSelectors_1 = require("../../../View/Modals/CommonFormComponents/BussinesObjectSelectors");
const GenericComponents_1 = require("../../../View/Modals/CommonFormComponents/GenericComponents");
const FormContext_1 = require("../../../View/Modals/FormContext");
/**
 * Zakładanie użytkownika z okna „Personel i uprawnienia" (PER-3).
 *
 * Dwie sekcje, bo powstają dwie różne rzeczy: osoba w książce adresowej i jej konto
 * w systemie. Kolejność pól i etykiety jak na skasowanym ekranie „Dodawanie użytkowników" -
 * to ten sam przepływ, tylko w innym oknie.
 *
 * TYLKO dodawanie. Uprawnienia i konto istniejącej osoby edytuje `StaffMemberModalBody`,
 * a jej dane kontaktowe - okno „Osoby". Dlatego nie ma tu doczytywania danych z tras v2:
 * przy zakładaniu nie ma czego doczytać.
 */
function UserModalBody({ initialData }) {
    const { register, reset, trigger, watch, formState: { errors }, } = (0, FormContext_1.useFormContext)();
    // Role ograniczone do przypisanych projektów muszą te projekty dostać przy zakładaniu,
    // inaczej konto powstaje bez dostępu do czegokolwiek.
    const isProjectScopedRole = MainSetupReact_1.default.isProjectScopedRoleId(watch("systemRoleId"));
    (0, react_1.useEffect)(() => {
        reset({
            _entity: initialData?._entity || null,
            name: "",
            surname: "",
            position: "",
            email: "",
            cellphone: "",
            phone: "",
            comment: "",
            systemRoleId: "",
            systemEmail: "",
            fidmanEnabled: false,
            // Celowo BEZ _projectAssignments - patrz `saveProjectAssignments`: brak pola
            // znaczy „nie ruszaj", pusta tablica znaczy „wyczyść". Przy zakładaniu nie ma
            // czego czyścić, a selektor doda pole, gdy rola go pokaże.
        });
        trigger();
    }, [initialData, reset]);
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: "fw-semibold mb-2" }, "Dane osoby"),
        react_1.default.createElement(react_bootstrap_1.Form.Group, null,
            react_1.default.createElement(react_bootstrap_1.Form.Label, null, "Podmiot"),
            react_1.default.createElement(BussinesObjectSelectors_1.EntitySelector, { name: "_entity", multiple: false })),
        react_1.default.createElement(react_bootstrap_1.Form.Group, { controlId: "name" },
            react_1.default.createElement(react_bootstrap_1.Form.Label, null, "Imi\u0119"),
            react_1.default.createElement(react_bootstrap_1.Form.Control, { placeholder: "Podaj imi\u0119", isInvalid: !!errors?.name, isValid: !errors?.name, ...register("name") }),
            react_1.default.createElement(GenericComponents_1.ErrorMessage, { name: "name", errors: errors })),
        react_1.default.createElement(react_bootstrap_1.Form.Group, { controlId: "surname" },
            react_1.default.createElement(react_bootstrap_1.Form.Label, null, "Nazwisko"),
            react_1.default.createElement(react_bootstrap_1.Form.Control, { placeholder: "Podaj nazwisko", isInvalid: !!errors?.surname, isValid: !errors?.surname, ...register("surname") }),
            react_1.default.createElement(GenericComponents_1.ErrorMessage, { name: "surname", errors: errors })),
        react_1.default.createElement(react_bootstrap_1.Form.Group, { controlId: "email" },
            react_1.default.createElement(react_bootstrap_1.Form.Label, null, "Email"),
            react_1.default.createElement(react_bootstrap_1.Form.Control, { type: "email", placeholder: "Podaj email kontaktowy", isInvalid: !!errors?.email, isValid: !errors?.email, ...register("email") }),
            react_1.default.createElement(GenericComponents_1.ErrorMessage, { name: "email", errors: errors })),
        react_1.default.createElement(react_bootstrap_1.Form.Group, { controlId: "position" },
            react_1.default.createElement(react_bootstrap_1.Form.Label, null, "Stanowisko"),
            react_1.default.createElement(react_bootstrap_1.Form.Control, { placeholder: "Podaj stanowisko", isInvalid: !!errors?.position, isValid: !errors?.position, ...register("position") }),
            react_1.default.createElement(GenericComponents_1.ErrorMessage, { name: "position", errors: errors })),
        react_1.default.createElement(react_bootstrap_1.Form.Group, { controlId: "cellphone" },
            react_1.default.createElement(react_bootstrap_1.Form.Label, null, "Telefon kom\u00F3rkowy"),
            react_1.default.createElement(react_bootstrap_1.Form.Control, { placeholder: "Podaj numer kom\u00F3rki", isInvalid: !!errors?.cellphone, ...register("cellphone") }),
            react_1.default.createElement(GenericComponents_1.ErrorMessage, { name: "cellphone", errors: errors })),
        react_1.default.createElement(react_bootstrap_1.Form.Group, { controlId: "phone" },
            react_1.default.createElement(react_bootstrap_1.Form.Label, null, "Telefon"),
            react_1.default.createElement(react_bootstrap_1.Form.Control, { placeholder: "Podaj numer telefonu", isInvalid: !!errors?.phone, ...register("phone") }),
            react_1.default.createElement(GenericComponents_1.ErrorMessage, { name: "phone", errors: errors })),
        react_1.default.createElement("hr", null),
        react_1.default.createElement("div", { className: "fw-semibold mb-2" }, "Konto w systemie"),
        react_1.default.createElement(react_bootstrap_1.Form.Group, { controlId: "systemEmail" },
            react_1.default.createElement(react_bootstrap_1.Form.Label, null, "Email systemowy"),
            react_1.default.createElement(react_bootstrap_1.Form.Control, { type: "email", placeholder: "Podaj gmail do logowania potrzebny do utworzenia konta na witrynie", isInvalid: !!errors?.systemEmail, ...register("systemEmail") }),
            react_1.default.createElement(GenericComponents_1.ErrorMessage, { name: "systemEmail", errors: errors })),
        react_1.default.createElement(BussinesObjectSelectors_1.SystemRoleSelector, { name: "systemRoleId" }),
        react_1.default.createElement(react_bootstrap_1.Form.Group, { controlId: "fidmanEnabled", className: "mt-2" },
            react_1.default.createElement(react_bootstrap_1.Form.Check, { type: "checkbox", label: "U\u017Cytkownik FIDmana (loguje si\u0119 tym samym kontem Google)", isInvalid: !!errors?.fidmanEnabled, ...register("fidmanEnabled") }),
            react_1.default.createElement(react_bootstrap_1.Form.Text, { className: "text-muted" }, "Konto w FIDmanie zak\u0142ada si\u0119 z e-maila systemowego. Odznaczenie wy\u0142\u0105cza je, nie kasuje."),
            react_1.default.createElement(GenericComponents_1.ErrorMessage, { name: "fidmanEnabled", errors: errors })),
        isProjectScopedRole && (react_1.default.createElement(react_bootstrap_1.Form.Group, { className: "mt-2" },
            react_1.default.createElement(BussinesObjectSelectors_1.ProjectSelector, { name: "_projectAssignments", multiple: true, label: "Przypisane projekty" }),
            react_1.default.createElement(react_bootstrap_1.Form.Text, { className: "text-muted" }, "Ta rola widzi wy\u0142\u0105cznie dane wskazanych tu projekt\u00F3w.")))));
}
